var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Flex, StatusWrapper, Text, } from 'shared/components';
import { SortableTable } from 'shared/features/table';
/**
 * A SortableTable component that includes a StatusWrapper and displays text when no data is available
 */
var StatusTable = function (_a) {
    var cols = _a.cols, data = _a.data, isLoading = _a.isLoading, isError = _a.isError, noData = _a.noData, initialState = _a.initialState, maxWidth = _a.maxWidth, paginated = _a.paginated, pageSizeOptions = _a.pageSizeOptions, preservedTableId = _a.preservedTableId, topPaginationProps = _a.topPaginationProps, cellProps = _a.cellProps, rowProps = _a.rowProps, props = __rest(_a, ["cols", "data", "isLoading", "isError", "noData", "initialState", "maxWidth", "paginated", "pageSizeOptions", "preservedTableId", "topPaginationProps", "cellProps", "rowProps"]);
    /**
     * Render the component
     */
    return (_jsx(_Fragment, { children: _jsx(StatusWrapper, __assign({ isLoading: isLoading, isError: isError }, { children: data && data.length > 0 ? (_jsx(SortableTable, __assign({ mt: 1, columns: cols, data: data, initialState: initialState, maxWidth: maxWidth, paginated: paginated, pageSizeOptions: pageSizeOptions, preservedTableId: preservedTableId, topPaginationProps: topPaginationProps, cellProps: cellProps, rowProps: rowProps }, props, { children: _jsx(SortableTable.TitleRow, { bg: "green.100" }) }))) : (noData || (_jsx(Flex, __assign({ alignContent: "center", justifyContent: "center", mt: 12 }, { children: _jsx(Text, __assign({ fontSize: "xl" }, { children: "There is no associated data found" })) })))) })) }));
};
export { StatusTable };
